// eslint-disable-next-line
export const BUILD_URL = 'BUILD_URL';
